import { BehaviorSubject } from "rxjs";
import { axiosWrapper } from "../clients/axiosWrapper";
//import bcrypt from 'bcryptjs';
import { RegisterUser } from "../models/Account";
import { User } from "../models/User";

const userSubject = new BehaviorSubject<User | null>(null);

const login = async (userName: string, password: string) => {
  try {
    await axiosWrapper.post("users/authenticate", { userName, password });
    const user: User = await axiosWrapper.get("users/user");
    userSubject.next(user);

    return user;
  } catch {
    throw new Error("Problems with login");
  }
};

const loginWithGoogle = async (token: string) => {
  try {
    await axiosWrapper.post("users/authenticate-google", { token });
    const user: User = await axiosWrapper.get("users/user");
    userSubject.next(user);

    return user;
  } catch {
    throw new Error("Problems with login with Google");
  }
};

const getUser = async () => {
  try {
    let user: User = await axiosWrapper.get("users/user");
    if (user) {
      userSubject.next(user);
    }
    return user;
  } catch {
    throw new Error("Problems with getting user");
  }
};

const logout = () => {
  axiosWrapper.post("users/logout", null);
  userSubject.next(null);
};

const register = ({ name, email, password }: RegisterUser) => {
  return axiosWrapper.post("users/register", {
    username: name,
    email,
    password,
  });
};

const registerWithGoogle = async (token: string) => {
  await axiosWrapper.post("users/register-google", { token });
  const user: User = await axiosWrapper.get("users/user");
  userSubject.next(user);
  return user;
}

//function verifyEmail(token) {
//    return fetchWrapper.post(`${baseUrl}/verify-email`, { token });
//}

const forgotPassword = (email: string) => {
  return axiosWrapper.post(`users/forgot-password`, { email });
};

//function validateResetToken(token) {
//    return fetchWrapper.post(`${baseUrl}/validate-reset-token`, { token });
//}

const resetPassword = ({
  token,
  password,
  confirmPassword,
}: {
  token: string;
  password: string;
  confirmPassword: string;
}) => {
  return axiosWrapper.post(`users/reset-password`, {
    token,
    password,
    confirmPassword,
  });
};

//function getAll() {
//    return fetchWrapper.get(baseUrl);
//}

//function getById(id) {
//    return fetchWrapper.get(`${baseUrl}/${id}`);
//}

//function create(params) {
//    return fetchWrapper.post(baseUrl, params);
//}

//function update(id, params) {
//    return fetchWrapper.put(`${baseUrl}/${id}`, params)
//        .then(user => {
//            // update stored user if the logged in user updated their own record
//            if (user.id === userSubject.value.id) {
//                // publish updated user to subscribers
//                user = { ...userSubject.value, ...user };
//                userSubject.next(user);
//            }
//            return user;
//        });
//}

//// prefixed with underscore because 'delete' is a reserved word in javascript
//function _delete(id) {
//    return fetchWrapper.delete(`${baseUrl}/${id}`)
//        .then(x => {
//            // auto logout if the logged in user deleted their own record
//            if (id === userSubject.value.id) {
//                logout();
//            }
//            return x;
//        });
//}

//// helper functions

export const accountService = {
  login,
  loginWithGoogle,
  logout,
  //  refreshToken,
  register,
  registerWithGoogle,
  //verifyEmail,
  forgotPassword,
  //validateResetToken,
  resetPassword,
  //getAll,
  //getById,
  //create,
  //update,
  //delete: _delete,
  user: userSubject.asObservable(),
  get userValue() {
    return userSubject.value;
  },
  getUser,
};
